import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

import { useAttendeeSessions } from 'common/components/TouchpointEditor/contexts/AttendeeSessionContext';
import { useEditor } from '@splashthat/splash-cms-engine';
import Collapse from 'common/components/Collapse';

export default function ActiveSessionWrapper({ children }) {
    const { activeSession = {} } = useAttendeeSessions();
    const editor = useEditor((state) => ({ editing: state.editing }));
    const hasActiveSession = !isEmpty(activeSession);
    const shouldShowSession = hasActiveSession || editor.editing;

    return <Collapse isOpen={shouldShowSession}>{shouldShowSession && children}</Collapse>;
}

ActiveSessionWrapper.propTypes = {
    children: PropTypes.node,
};

ActiveSessionWrapper.defaultProps = {
    children: null,
};
